import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  exports: [RouterModule]
})
export class AppRoutingModule {}
